import { Component, OnInit, Inject, Input } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { color } from "d3";
import { CrudService } from "src/app/Services/crud.service";

@Component({
  selector: "app-usage-analytic-details",
  templateUrl: "./usage-analytic-details.component.html",
  standalone: false,
})
export class UsageAnalyticDetailsComponent implements OnInit {
  @Input() data;
  ratingCounts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };

  barChartOptions = {
    responsive: true,
    indexAxis: "y", // makes it horizontal
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          color: "#000", // x-axis labels color
        },
      },
      y: {
        ticks: {
          color: "#000", // y-axis labels color
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        labels: {
          color: "#000", // legend text color
        },
      },
    },
  };

  barChartLabels = ["5", "4", "3", "2", "1"];

  barChartType = "bar"; // always 'bar' in Chart.js v4
  barChartLegend = true;

  barChartData = [
    {
      data: [],
      label: "Rating Count",
      backgroundColor: "#032d55",
      hoverBackgroundColor: "#2083e9",
      borderColor: "#ffffff",
      hoverBorderColor: "#2083e9",
    },
  ];

  title = "";
  thumbsUpCount = 0;
  thumbsDownCount = 0;

  constructor(
    private translateService: TranslateService,
    private crudService: CrudService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.getFeedbackInDetail(this.data);
  }

  getFeedbackInDetail(ref) {
    this.title = `${
      ref.refType === "workflow" || ref.refType === "userguide"
        ? ref.refType.charAt(0).toUpperCase() + ref.refType.slice(1)
        : ref.refType
    } - ${ref.refName}`;
    this.crudService.get(
      null,
      (response) => {
        if (response) {
          response.forEach((item) => {
            this.ratingCounts[item.rating]++;
            if (item.thumbsUp) this.thumbsUpCount++;
            if (item.thumbsDown) this.thumbsDownCount++;
          });
          this.barChartData = [
            {
              data: [
                this.ratingCounts[5],
                this.ratingCounts[4],
                this.ratingCounts[3],
                this.ratingCounts[2],
                this.ratingCounts[1],
              ],
              label: "Rating Count",
              backgroundColor: "#032d55",
              hoverBackgroundColor: "#2083e9",
              borderColor: "#ffffff",
              hoverBorderColor: "#2083e9",
            },
          ];
        }
      },
      "feedbacks?filter[where][refId]=" + ref.refId
    );
  }
}
